// Imports de imagens - Laudos
import parecer1 from "../pages/img/parecer1.JPG";
import parecer2 from "../pages/img/parecer2.JPG";
import parecer3 from "../pages/img/parecer3.jpg";
import parecer from "../pages/img/parecer.jpg";

// Imports de imagens - Florestal
import f1 from "../pages/img/f1.JPG";
import f2 from "../pages/img/f2.JPG";
import f3 from "../pages/img/f3.JPG";
import f4 from "../pages/img/f4.JPG";

// Imports de imagens - Fauna
import a1 from "../pages/img/a1.JPG";
import a2 from "../pages/img/a2.jpg";
import a3 from "../pages/img/a3.jpg";

// Imports de imagens - Propriedade Intelectual
import p1 from "../pages/img/p1.jpg";
import p2 from "../pages/img/p2.jpg";
import p3 from "../pages/img/p3.jpg";
import p4 from "../pages/img/p4.jpg";

// Imports de imagens - Drones
import g1 from "../pages/img/g1.jpg";
import g2 from "../pages/img/g2.jpg";
import g3 from "../pages/img/g3.jpg";
import g4 from "../pages/img/g4.JPG";

// Imports de imagens - Levantamentos
import t1 from "../pages/img/t1.jpg";
import t2 from "../pages/img/t2.jpg";
import t3 from "../pages/img/t3.jpg";
import t4 from "../pages/img/t4.JPG";

// Imports de imagens - Capex
import c1 from "../pages/img/c1.jpg";
import c2 from "../pages/img/c2.jpg";
import c3 from "../pages/img/c3.jpg";
import c4 from "../pages/img/c4.jpg";

// Imports de imagens - Digital
import d1 from "../pages/img/dig1.jpg";
import d2 from "../pages/img/dig2.jpg";
import d3 from "../pages/img/dig3.jpg";

export const servicesData = [
  {
    id: "laudos",
    title: "Licenciamento Ambiental e Regularização",
    description: "Obtenção de licenças prévias, de instalação ou de operação para empreendimentos diversos. Estudos de Impacto Ambiental (EIA), Relatórios de Impacto Ambiental (RIMA) e Relatórios Simplificados (RAS).",
    icon: "fas fa-solid fa-file-contract",
    route: "/laudos",
    subServices: [
      {
        title: "Obtenção de Licenças Ambientais",
        description: "Auxiliamos no processo de obtenção de licenças prévias, de instalação e de operação para diferentes tipos de empreendimentos, como rodovias, ferrovias, indústrias, linhas de transmissão e obras em geral.",
        image: parecer1
      },
      {
        title: "EIA - RIMA",
        description: "Desenvolvemos Estudos de Impacto Ambiental e Relatórios de Impacto Ambiental (EIA/RIMA) detalhados, essenciais para a aprovação de empreendimentos junto aos órgãos ambientais.",
        image: parecer2
      },
      {
        title: "Relatórios Ambientais Simplificados (RAS)",
        description: "Elaboramos Relatórios Ambientais Simplificados (RAS) para atender a empreendimentos de menor impacto ambiental, garantindo agilidade no processo de licenciamento.",
        image: parecer3
      },
      {
        title: "Supervisão de Obras e Empreendimentos",
        description: "Realizamos a supervisão de obras e empreendimentos, assegurando o cumprimento das condicionantes ambientais e promovendo a sustentabilidade em todas as etapas do projeto.",
        image: parecer
      }
    ]
  },
  {
    id: "florestal",
    title: "Flora",
    description: "Realizamos inventários florestais, elaboração de planos e documentos para Austorizações de Supressão Vegetal (ASV). Além de avaliar, identificar e mapear cobertura vegetal para recuperação de áreas degradadas.",
    icon: "fas fa-solid fa-tree",
    route: "/florestal",
    subServices: [
      {
        title: "Inventários Florestais",
        description: "Avaliamos a composição, estrutura e dinâmica da vegetação, auxiliando em projetos de manejo sustentável e recuperação ambiental.",
        image: f3
      },
      {
        title: "Diagnóstico de Vegetação",
        description: "Oferecemos diagnósticos detalhados da vegetação para embasar ações de conservação e manejo sustentável.",
        image: f1
      },
      {
        title: "Elaboração de Planos para Autorizações de Supressão Vegetal (ASV)",
        description: "Elaboramos planos e documentos técnicos para obtenção de ASV, garantindo conformidade legal e compensação ambiental adequada.",
        image: f2
      },
      {
        title: "Caracterização Vegetal",
        description: "Mapeamos a cobertura vegetal com alta precisão, facilitando o planejamento ambiental.",
        image: f4
      }
    ]
  },
  {
    id: "fauna",
    title: "Fauna",
    description: "Elaboração de Planos de Manejo da Fauna em Aeródromos (PMFA), Resgate, Afugentamento e Monitoramento de Fauna em áreas de impacto, Inventários de Biodiversidade e Monitoramento de Fauna Atropelada.",
    icon: "fas fa-solid fa-frog",
    route: "/fauna",
    subServices: [
      {
        title: "Planos de Manejo da Fauna em Aeródromos (PMFA)",
        description: "Desenvolvemos planos de manejo e soluções personalizadas para preservação ambiental.",
        image: a1
      },
      {
        title: "Resgate, Afugentamento e Monitoramento de Fauna",
        description: "Implementação de estratégias para restaurar ecossistemas degradados e promover a biodiversidade.",
        image: a2
      },
      {
        title: "Restauro Ecológico",
        description: "Implementação de estratégias para restaurar ecossistemas degradados e promover a biodiversidade.",
        image: a3
      }
    ]
  },
  {
    id: "propriedade-intelectual",
    title: "Propriedade Intelectual",
    description: "A Biolink protege sua inovação ambiental, oferecendo suporte estratégico em patentes, marcas, softwares e soluções, alinhando tecnologias sustentáveis à legislação vigente.",
    icon: "fas fa-solid fa-microscope",
    route: "/propriedade-intelectual",
    subServices: [
      {
        title: "Registro de Patentes",
        description: "Oferecemos suporte técnico e estratégico para o registro de patentes relacionadas a inovações e tecnologias ambientais.",
        image: p1
      },
      {
        title: "Registro de Marcas e Softwares",
        description: "Auxiliamos no registro de marcas, softwares e soluções digitais voltadas para práticas e metodologias ambientais exclusivas.",
        image: p2
      },
      {
        title: "Proteção de Invenções",
        description: "Realizamos análises técnicas e jurídicas para garantir a proteção de invenções e tecnologias desenvolvidas para restauração ecológica e sustentabilidade.",
        image: p3
      },
      {
        title: "Submissão de Documentos",
        description: "Acompanhamos o desenvolvimento e a submissão de documentos necessários para o registro e proteção de produtos e soluções ambientais.",
        image: p4
      }
    ]
  },
  {
    id: "drones",
    title: "Drones e Geoprocessamento",
    description: "Empregamos drones e geoprocessamento para monitoramento ambiental, análises espaciais, mapas temáticos, zoneamentos e recuperação de áreas degradadas com precisão e inovação.",
    icon: "fas fa-solid fa-map",
    route: "/drones",
    subServices: [
      {
        title: "Monitoramento com Drones",
        description: "Utilizamos drones com sensores avançados para fotografias e monitoramento de obras, plantios compensatórios, passivos ambientais e áreas de preservação permanente.",
        image: g1
      },
      {
        title: "Mapeamento Aéreo",
        description: "Realizamos mapeamentos precisos para análise de vegetação, topografia e uso do solo, identificando áreas degradadas e planejando ações de recuperação ambiental.",
        image: g2
      },
      {
        title: "Gestão de Áreas Protegidas",
        description: "Oferecemos monitoramento contínuo de áreas protegidas, delimitação de unidades de conservação e análises de corredores ecológicos e uso do solo.",
        image: g3
      },
      {
        title: "Geoprocessamento Avançado",
        description: "Elaboramos mapas temáticos, análises espaciais, zoneamentos ambientais e estudos de impacto com ferramentas de geoprocessamento de última geração.",
        image: g4
      }
    ]
  },
  {
    id: "levantamentos",
    title: "Treinamentos e Capacitação",
    description: "Oferecemos treinamentos especializados, incluindo PGR e PAE, manejo de fauna, resgate de espécies e educação ambiental, capacitando equipes, promovendo a preservação da biodiversidade e conscientização ambiental.",
    icon: "fas fa-solid fa-users",
    route: "/levantamentos",
    subServices: [
      {
        title: "Programas de Gerenciamento de Riscos (PGR)",
        description: "Oferecemos treinamentos especializados para identificação, avaliação e gestão de riscos ambientais em empreendimentos.",
        image: t1
      },
      {
        title: "Planos de Ação de Emergência (PAE)",
        description: "Capacitamos equipes para desenvolver e executar planos eficazes em situações de emergência ambiental.",
        image: t2
      },
      {
        title: "Treinamentos sobre Fauna",
        description: "Promovemos treinamentos em resgate, manejo e monitoramento de espécies, preparando equipes para atuar em áreas que demandam manejo de biodiversidade.",
        image: t4
      },
      {
        title: "Educação Ambiental",
        description: "Realizamos oficinas e programas educativos para comunidades e gestores, promovendo a conscientização e a preservação do meio ambiente.",
        image: t3
      }
    ]
  },
  {
    id: "capex",
    title: "Capex Opex",
    description: "Oferecemos consultoria em CAPEX e OPEX socioambiental, otimizando investimentos, reduzindo riscos legais e alinhando projetos às melhores práticas de sustentabilidade, licenciamento ambiental e monitoramento contínuo.",
    icon: "fas fa-solid fa-compass",
    route: "/capex",
    subServices: [
      {
        title: "Gestão de CAPEX Socioambiental",
        description: "Identificamos e planejamos custos iniciais de empreendimentos, como estudos ambientais, aquisição de equipamentos e cumprimento de exigências legais.",
        image: c1
      },
      {
        title: "Gestão de OPEX Socioambiental",
        description: "Auxiliamos no monitoramento de custos operacionais contínuos, incluindo monitoramentos ambientais e manutenção de práticas sustentáveis.",
        image: c2
      },
      {
        title: "Planejamento Socioambiental Estratégico",
        description: "Apoiamos empresas na alocação de recursos para ações como licenciamento ambiental, compensações e recuperação de áreas degradadas.",
        image: c3
      },
      {
        title: "Otimização de Recursos Socioambientais",
        description: "Garantimos a otimização de investimentos, reduzindo riscos e alinhando práticas às melhores estratégias de sustentabilidade.",
        image: c4
      }
    ]
  },
  {
    id: "digital",
    title: "Desenvolvimento de Soluções Digitais",
    description: "Desenvolvemos soluções digitais para gestão ambiental, como aplicativos, sistemas geográficos e ferramentas automatizadas, otimizando monitoramento de biodiversidade, análise de impactos e eficiência nos projetos.",
    icon: "fas fa-solid fa-desktop",
    route: "/digital",
    subServices: [
      {
        title: "Aplicativos para Coleta de Dados",
        description: "Desenvolvemos aplicativos personalizados para coleta de dados em campo, otimizando a eficiência e precisão das informações ambientais.",
        image: d1
      },
      {
        title: "Sistemas para Gestão Digital de Projetos",
        description: "Nossas soluções utilizam tecnologias avançadas para otimizar a eficiência dos projetos, facilitar a tomada de decisão e garantir a integração de dados de forma prática e acessível.",
        image: d2
      },
      {
        title: "Automação de Processos Ambientais",
        description: "Desenvolvemos sistemas para automatizar processos, como emissão de relatórios, gestão de licenças e monitoramento de conformidade ambiental.",
        image: d3
      }
    ]
  }
];
